export default theme => ({

  content: {
    marginTop: theme.spacing.unit * 8,
    padding: 0,
    overflow: 'hidden',
    height: '100%'
  },

  toolbar: {
    'justify-content': 'space-between'
  },

  header: {
    width: '100%',
    paddingLeft: theme.spacing.unit
  }

});




// WEBPACK FOOTER //
// ./src/styles/components/NodeInfo.js